import { Route, Routes } from "react-router-dom";
import MainDashboard from "./Layout/MainDashboard";
import Dashboard from "./Vendor/Dashboard/Dashboard";
import Booking from "./Vendor/Booking/Booking";
import Customer from "./Vendor/Customer/Customer";
import Expense from "./Vendor/Expense/Expense";
import Setting from "./Vendor/Setting/Setting";
import Table from "./Vendor/Table/Table";
import Dues from "./Vendor/Dues/Dues";
import LogOut from "./Common/LogOut";
import ViewCustomer from "./Vendor/Customer/ViewCustomer";
import AttendanceHistory from "./Vendor/Staff/AttendanceHistory";
import TransactionReport from "./Vendor/Report/TransactionReport/TransactionReport";
import CollectionReport from "./Vendor/Report/CollectionReport/CollectionReport";
import GameHistory from "./Vendor/Report/GameHistory/GameHistory";
import ViewStaff from "./Vendor/Staff/ViewStaff";
import Role from "./Vendor/Role/Role";
import ViewPlayers from "./Vendor/Booking/ViewPlayers";
import PaymentHistory from "./Vendor/Customer/PaymentHistory";
import PlayerBookings from "./Vendor/Customer/PlayerBookings";
import ViewAllNotification from "./Common/ViewAllNotification";
import DashboardCt from "./Canteen/Dashboard/DashboardCt";
import ViewOrder from "./Canteen/Dashboard/ViewOrder";
import AllOrdersDetails from "./Canteen/Dashboard/AllOrdersDetails";
import AddOrder from "./Canteen/Orders/AddOrders";
import Additems from "./Canteen/Items/AddItems";
import StockList from "./Canteen/Stock/AddStocks";
import AddCanteen from "./Vendor/CanteenUser/AddCanteen";
import AddStocks from "./Canteen/Stock/AddStocks";
import AddStockForm from "./Canteen/Stock/AddStockForm";
import Menus from "./Canteen/Menus/Menus";
import CreateOrder from "./Canteen/Menus/CreateOrder";
import AddStaff from "./Vendor/Staff/AddStaff";
import AddCombo from "./Canteen/Combo/AddCombo";
import AddComboFrom from "./Canteen/Combo/AddComboFrom";
import PaymentsRecords from "./Vendor/Report/PayHistory/PaymentsRecords";
import SalesReport from "./Canteen/Report/SalesReport/SalesReport";
import CollectionReports from "./Canteen/Report/CollectionReport/CollectionReports"
import Expenses from "./Canteen/Expenses/Expenses";

// import PayLater from "./Vendor/Booking/PayLater";

const MainRoutes = () => {
  return (
    <MainDashboard>
      <Routes>
        {/* Vendor Dashboard */}
        {/* Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Dues */}
        <Route path="/dues" element={<Dues />} />

        {/* Booking */}
        <Route path="/booking" element={<Booking />} />
        {/* <Route path="/booking/payLater/:id" element={<PayLater />} /> */}
        <Route path="/booking/viewPlayers" element={<ViewPlayers />} />

        {/* Customer */}
        <Route path="/customer" element={<Customer />} />
        <Route path="/customer/viewCustomer/:id" element={<ViewCustomer />} />
        <Route
          path="/customer/viewCustomer/paymenthistory/:id"
          element={<PaymentHistory />}
        />
        <Route
          path="/customer/viewCustomer/bookings/:id"
          element={<PlayerBookings />}
        />

        {/* Expense */}
        <Route path="/expense" element={<Expense />} />

        {/* Report */}
        <Route
          path="/report/transactionReport"
          element={<TransactionReport />}
        />
        <Route path="/report/collectionReport" element={<CollectionReport />} />
        <Route path="/report/gameHistory" element={<GameHistory />} />
        <Route path="/report/paymentsRecords" element={<PaymentsRecords />} />

        {/* Setting */}
        <Route path="/setting" element={<Setting />} />

        {/* Staff */}
        <Route path="/staff" element={<AddStaff />} />
        <Route
          path="/staff/attendanceHistory"
          element={<AttendanceHistory />}
        />
        <Route path="/staff/viewStaff/:id" element={<ViewStaff />} />

        {/* Table */}
        <Route path="/table" element={<Table />} />

        {/* LogOut */}
        <Route path="/logOut" element={<LogOut />} />

        {/* Roles */}
        <Route path="/role" element={<Role />} />

        {/* Category */}
        <Route path="/addCanteen" element={<AddCanteen />} />

        {/* View all notification */}
        <Route path="/viewAllNotification" element={<ViewAllNotification />} />

        {/* ********************* Cateeen Flow ************************** */}
        <Route path="/dashboardCt" element={<DashboardCt />} />
        <Route path="/dashboardCt/viewOrder/:id" element={<ViewOrder />} />
        <Route
          path="/dashboardCt/allOrdersDetails"
          element={<AllOrdersDetails />}
        />
        <Route path="/addOrder" element={<AddOrder />} />
        <Route path="/additems" element={<Additems />} />
        <Route path="/StockList" element={<StockList />} />
        <Route path="/dashboardCt/addStockForm" element={<AddStockForm />} />
        <Route path="/report/salesReport" element={<SalesReport />} />
        <Route path="/report/collectionReports" element={<CollectionReports />} />
        <Route path="/canteenexpense" element={<Expenses />} />
        <Route path="/dashboardCt/addStock" element={<AddStocks />} />
        <Route path="/addcombo" element={<AddCombo />} />
        <Route path="/comboForm" element={<AddComboFrom />} />

        {/* canteen Postpaid flow */}
        <Route path="/menusList" element={<Menus />} />
        <Route path="/createOrder" element={<CreateOrder />} />
      </Routes>
    </MainDashboard>
  );
};

export default MainRoutes;
